/**
 * Participant roster data cells should match the Gender column: inherit the table body
 * `text-sm` and default foreground. Do not use `text-muted-foreground`, `text-xs`, or
 * `font-sans` on plain data values (including "Not Applicable" or "-").
 */
export const PARTICIPANT_ROSTER_DATA_TEXT_CLASS = 'text-foreground';
